import ApiNode from './ApiNode.js';
export default {

  getTATJobList(payload, config) {
    let getTrack = ApiNode().post("get-common-job/get-tat-job-list", payload, config);
    return getTrack;
  },

  exportTATJobList(payload, config) {
    let getTrack = ApiNode().post("get-common-job/export-tat-job-list", payload, config);
    return getTrack;
  }

}



// WEBPACK FOOTER //
// ./src/services/TATService.js